import PersistenceRegistry from '../base/redux/PersistenceRegistry';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { SET_PARTICIPANTS_LAYOUT } from './actionTypes';
import { DEFAULT_PARTICIPANTS_LAYOUT, STORE_NAME } from './constants';
const DEFAULT_STATE = {
    layout: DEFAULT_PARTICIPANTS_LAYOUT
};
// Persist the user's choice across reloads (like the theme selection).
PersistenceRegistry.register(STORE_NAME, true, DEFAULT_STATE);
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_PARTICIPANTS_LAYOUT:
            return {
                ...state,
                layout: action.layout
            };
        default:
            return state;
    }
});
